export default __webpack_public_path__ + "static/media/IE.097ac3ed.svg";